var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"plans-card"},[(!_vm.hasPlans)?_c('plans-button',{on:{"button-click":_vm.goToPlanAheadPage}}):_c('plans-section',{attrs:{"plans":_vm.plans}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }